import { RequestHelper } from "@lib-shared/lib";
import { appSettings } from "core/config";
import UrlUtils from "core/lib/url-utils";

export type SocialLink = {
    type: string,
    url: string
}

export type ContactDetails = {
    contactNumber: string,
    socialLinks: SocialLink[]
}

class UmbracoService {
    baseUrl = appSettings.urls.umbracoApi || "/umbraco/api";

    getContactDetails() {
        const languageCode = UrlUtils.getLanguageCode();
        return this._createStandardPromiseRequest(`/contact/get?culture=${languageCode}`).get<ContactDetails>();
    }

    _createStandardPromiseRequest(path: string) {
        const helper = new RequestHelper(this.baseUrl).withPath(path);

        return helper.usingPromise();
    }
}

export default UmbracoService;
